module.exports = __webpack_public_path__ + "static/media/DMAGIC     -logo.a756c37a.png";